// src/validation/configTaxaConvenienciaSchema.ts
import { z } from 'zod';

// Campos opcionais: string vazia -> null. Percentual entre 0 e 100; valor fixo >= 0.
const percentualField = z
  .union([z.string(), z.number()])
  .optional()
  .transform((v) => (v === '' || v === undefined || v === null ? null : Number(v)))
  .refine((v) => v === null || (!Number.isNaN(v) && v >= 0 && v <= 100), {
    message: 'Informe um percentual entre 0 e 100.',
  });

const valorFixoField = z
  .union([z.string(), z.number()])
  .optional()
  .transform((v) => (v === '' || v === undefined || v === null ? null : Number(v)))
  .refine((v) => v === null || (!Number.isNaN(v) && v >= 0), {
    message: 'Informe um valor maior ou igual a zero.',
  });

export const configTaxaConvenienciaSchema = z.object({
  pixPercentual: percentualField,
  pixValorFixo: valorFixoField,
  cartaoPercentual: percentualField,
  cartaoValorFixo: valorFixoField,
});

export type ConfigTaxaConvenienciaFormValues = z.input<typeof configTaxaConvenienciaSchema>;
